import { useCallback, useEffect, useRef, useState, type ReactNode } from 'react';

import { ToastContext, type ShowToast } from './toastContext';

/** One short confirmation at a time, bottom center, 2.4 s (prototype .toast). */
export function ToastProvider({ children }: { children: ReactNode }) {
  const [message, setMessage] = useState<string | null>(null);
  const timer = useRef<ReturnType<typeof setTimeout>>();

  const show = useCallback<ShowToast>((next) => {
    setMessage(next);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setMessage(null), 2400);
  }, []);

  useEffect(() => () => clearTimeout(timer.current), []);

  return (
    <ToastContext.Provider value={show}>
      {children}
      <div
        role="status"
        aria-live="polite"
        className={`fixed bottom-6 left-1/2 z-[300] max-w-[calc(100%-32px)] -translate-x-1/2 rounded-full bg-ink px-[18px] py-2.5 text-center font-text text-sm text-white shadow-[0_14px_30px_-14px_rgba(0,0,0,0.6)] ${
          message ? '' : 'hidden'
        }`}
      >
        {message}
      </div>
    </ToastContext.Provider>
  );
}
